import styled, { css } from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  theme: any;
  isLcsBanner?: boolean;
  isTitle?: string | null;
}

export const Wrapper = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  min-width: ${rem(88)};
  padding: ${rem(18)} ${rem(16)};
  margin-right: ${rem(12)};
  background: ${({ theme }) => theme.color['gray-100']};
  border-radius: ${rem(8)};
  justify-content: space-between;
  ${({ isLcsBanner, theme }) =>
    isLcsBanner ?
    css`
      background: ${theme.color['primary-50']};
      //gap: ${rem(34)};
    ` :css `
        //gap: ${rem(24)};
    `
  }
  ${({ theme }) => theme.media.fold`
      min-height: ${rem(120)};
      max-height: ${rem(120)};
  `};
  min-height: ${rem(124)};
  max-height: ${rem(124)};
`;
